import { z } from 'zod'
import { makeFieldKeys, validateWithZodSchema } from '../../core/utils/utilities.ts'

export const AccountRoleChoicesModelSchema = z
  .object({
    id: z.string(),
    role: z.string(),
    // True when reconcile_account_roles auto-manages this role (cfg.account_role_rules
    // signal). The account form renders these read-only.
    is_auto_assigned: z.boolean().nullish()
  })
  .strict()

const AccountRoleChoicesModelFields = makeFieldKeys(AccountRoleChoicesModelSchema)

export type AccountRoleChoicesModel = z.infer<typeof AccountRoleChoicesModelSchema>

function validateAccountRoleChoicesModel(data: unknown): AccountRoleChoicesModel {
  try {
    return validateWithZodSchema(AccountRoleChoicesModelSchema, data, 'account role choices model')
  } catch (error) {
    throw new Error(`Account role choices model validation failed: ${error}`)
  }
}
